import {IState} from 'angular-ui-router';
import {RouterHelper} from '../dvbModules/router/route-helper-provider';

statistikRun.$inject = ['RouterHelper'];

/* @ngInject */
export function statistikRun(routerHelper: RouterHelper) {
    routerHelper.configureStates(getStates());
}

function getStates(): IState[] {
    return [
        {
            name: 'statistik',
            template: '<dv-statistik-view></dv-statistik-view>',
            url: '/statistik'
        },

    ];
}






// WEBPACK FOOTER //
// ./src/app/statistik/statistik.route.ts